import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import "./takeawayor.css";
import App from "./App";
import Login from "./login";
import MLogin from "./merchantlogin";
import MerchantProductManagement from "./editpage";
import DesignPanel from "./designpanel";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/login" element={<Login />} />

      {/* Merchant tarafı */}
      <Route path="/mlogin" element={<MLogin />} />
      <Route path="/editday" element={<MerchantProductManagement />} />
      <Route path="/designpanel" element={<DesignPanel />} />

      {/* Eski kiosk route'ları artık App'e dönsün */}
      <Route path="/takeawayor" element={<App />} />
      <Route path="/selective" element={<App />} />
      <Route path="/designday" element={<App />} />
    </Routes>
  </Router>
);

reportWebVitals();